import request from '@/service/lib/request'

/**
 * 赤霉病 - 获取第三方token
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getToken() {
  return request({
    url: '/api/v1/gibberella/token',
    method: 'get'
  })
}

/**
 * 赤霉病 - 获取预测数据
 * @param {String} url 请求地址
 * @param {Object} key 设备编号
 */
export function getPredict(id) {
  return request({
    url: `/api/v1/gibberella/${id}/disease-rate`,
    method: 'get'
  })
}

/**
 * 赤霉病 - 获取传感器数据
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
   startDate: 'YYYY-MM-DD 00:00:00'
   endDate: 'YYYY-MM-DD 23:59:59'
   deviceId
   token
 */
export function getRawData(id, params) {
  return request({
    url: `/api/v1/gibberella/${id}/raw-data`,
    method: 'get',
    params
  })
}

/**
 * 赤霉病 - 获取传感器种类
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
   startDate: 'YYYY-MM-DD 00:00:00'
   endDate: 'YYYY-MM-DD 23:59:59'
   deviceId
   token
 */
export function getCols(key) {
  return request({
    url: `/api/v1/gibberella/${key}/raw-data/cols`,
    method: 'get'
  })
}
